import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';
import { HttpErrorResponse } from '@angular/common/http';
import { TclcFeesProcessComponent } from '../tclc-fees-process/tclc-fees-process.component';
@Component({
  selector: 'app-tclc-fees',
  templateUrl: './tclc-fees.component.html',
  styleUrls: ['./tclc-fees.component.scss']
})
export class TclcFeesComponent implements OnInit {
  FeeForm: FormGroup;
  FeeTempletList: any;
  FeeModeList: any;
  FeeTempList: any;
  payBtnShow;
  PayBtn = true;
  PayStatus = false;
  StudentIdd: string;
  FeePaid: string;
  StuData: any;
  constId = 0;
  StudentType: '';
  StudentStatus: '';
  Constitution: '';
  Caste: '';
  ShowMsg = false;
  FeeTable: [];
  feeApplyArray: FormArray;
  dialogRef: MatDialogRef<any>;
  ADMRecords: any[];
  Dates: any[];
  Message: string;
  ApprovalCheck = false;
  Message2: string;
  TempMsg = false;
  Message3 = '';
  FullName: string;
  TclcId: any;
  TclcData: any;
  StuId: any;
  Certificate: string;
  TclcSavedData: any;
  constructor(private fb: FormBuilder,
    public umsService: UmsService,
    public dialog: MatDialog, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService) { }
  sessionNo = sessionStorage.getItem('session');
  collegeName
  courseName
  Tclcdata = [];
  ngOnInit(): void {
    this.TclcId = 0
    this.prepopulation()
    this.TclcSavedData = this.umsService.getTclcData();
    this.GetTclcdata(this.TclcSavedData)
    this.PayBtn = true;
    this.ShowMsg = false;
    this.Message = '';
    this.ApprovalCheck = false;
    this.Message2 = '';
    this.TempMsg = false;
    this.Message3 = '';
    this.PayStatus = false;
    // this.ValidateFees()
    // this.getRgId(this.TclcData);
    // this.getFeeTempData();
    // this.getFeeModeData();
    this.getFeeTempData(this.TclcData);
    this.ValidatePayment()
  }



  GetTclcdata(Data) {
    console.log(Data);
    
    const payload = {};
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CertType'] = Data[0].CertType
    payload['StuId'] = this.TclcSavedData[0]['StuId']
    payload['IsStudent'] = 1
    this.umsService.GetTclcData(payload).subscribe((res) => {
      if (res.status) {

        // this.Tclcdata = res.data.filter(data => data.StuId == this.TclcSavedData[0]['StuId'])
        this.Tclcdata = res.data
        console.log(this.Tclcdata, 'tclc');

        this.getTclc()
        switch (this.Tclcdata[0]['CertType']) {
          case "PC":
            this.Certificate = 'Provisional Passing Certificate'
            this.payBtnShow = true;
            break;
          case "MC":
            this.Certificate = 'Migration Certificate'
            this.payBtnShow = true;
            break
          case "OPC":
            this.Certificate = 'Original Passing Certificate'
            this.payBtnShow = true;
            break;
          case "RC":
            this.Certificate = 'Rank Certificate'
            this.payBtnShow = true;
            break;
          default:

            break
        }
        // this.Tclcdata = res.data[0]
      }
    })
  }

  ValidateFees() {
    const payload = {}
    payload['StuId'] = this.TclcSavedData[0]['StuId']
    payload['FeeType'] = this.TclcSavedData[0]['CertType'];
    payload['SnNo'] = sessionStorage.getItem('session');
    this.umsService.ValidateFees(payload).subscribe(res => {
      this.getRgId(this.TclcSavedData);
      // this.getFeeTempData();
      this.getFeeModeData();
    })
  }

  ValidatePayment() {
    this.spinner.show();
    const payload = {}
    payload['StuId'] = this.TclcSavedData[0]['StuId']
    this.umsService.checkUnClearedSinglePayment(payload).subscribe((res) => {
      this.spinner.hide();
      this.ValidateFees();
    }, (ERROR: HttpErrorResponse) => {
      alert(ERROR.error.message);
      this.spinner.hide();
    }
    )
  }

  getFeeModeData() {
    // this.spinner.show();
    const payload = {};
    payload["Session"] = parseInt(this.sessionNo);
    payload['College'] = sessionStorage.getItem("StuCgId"),
      this.umsService.fetchCheckFeeMode(payload).subscribe(res => {
        // this.spinner.hide();
        this.FeeModeList = res.data;
        sessionStorage.setItem('FeeMode', res.data[0].FeeMode);

        if (res.data[0].FeeMode == 'ONLIN') {
          this.payBtnShow = true;
        } else {
          this.payBtnShow = false;
        }
      });
  }

  getcollege(CgCode) {
    const payload = {};
    payload['CgCode'] = CgCode
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeName = res.data[0].CgName;

    }, (ERROR: HttpErrorResponse) => {
      // this.collegedataList = [];
      this.spinner.hide();
    })
  }


  getCourse(CoCode) {
    const payload = {};
    payload['CoCode'] = CoCode
    this.umsService.fetchCourseType(payload).subscribe(res => {
      this.spinner.hide();
      this.courseName = res.data[0].CoName;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getFeeTempData(TclcData) {

    this.spinner.show();
    const payload = {};
    payload['FeeType'] = this.TclcSavedData[0]['CertType'];
    console.log(payload,'certtype');
    
    this.umsService.fetchFeeTempTclc(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        console.log(res,'feetable');
        
        this.TempMsg = false;
        this.Message3 = '';
        // this.Table = true;
        this.FeeTable = res.data;
        this.StudentIdd = sessionStorage.getItem("StudentRGID");
        this.SearchFeeDetails(res.data[0]['TemplateCode'], this.StudentIdd)

      } else {
        this.spinner.hide();
        if (res.message == 'No Data Found') {
          // this.Table = false;
          this.FeeTable = [];
          this.TempMsg = true;
          this.Message3 = 'Template Not Defined For This Criteria';
          this.ShowMsg = false;
          this.Message = ''
        }

      }
    });
  }

  prepopulation() {
    // this.spinner.show();
    let payload = {};
    payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {

        this.FullName = res.data[0]['StuFirstNameEng'] + " " + res.data[0]['StuMidNameEng'] + " " + res.data[0]['StuLastNameEng']
        this.StuId = res.data[0].StuId
        this.GetTclcdata(this.TclcSavedData)
        this.prepopulationOfAddmission(res.data[0].StuId)
      }
      else {
        this.GetTclcdata(this.TclcSavedData)
      }
    })
  }

  prepopulationOfAddmission(StuId) {
    // this.spinner.show();
    let payload = {};
    payload['StuId'] = StuId;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        this.getcollege(res.data[0].StuCgId)
        this.getCourse(res.data[0].StuCoId)
      }
    })
  }

  SearchFeeDetails(TempCode, StdId) {
    this.spinner.show();
    const payload = {};
    // payload['TemplateCode'] =  this.tempCo;
    payload['FeeTemplateCode'] = TempCode;
    payload['StuId'] = this.TclcSavedData[0]['StuId']
    payload['FeeHistory'] = 0;
    payload['SnNo'] = this.sessionNo
    console.log(payload,'search fee');
    
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {


      this.spinner.hide();
      if (res.status) {
        console.log(res,'table');
        let data = 0
        res.data.forEach(element => {
          data += element.FeeAmt
        });
        if (data == res.data[0]['TotalPaidAmount']) {
          this.PayBtn = false;
          this.PayStatus = true;
          this.FeePaid = 'Fees Paid'
        }
        else if (data != res.data[0]['TotalPaidAmount']) {
          this.PayBtn = true;
          this.PayStatus = false;
        }



      } else {
        console.log('im in else for fee details');
        this.payBtnShow = true;
        this.PayBtn = true;
        this.PayStatus = false;
      }
    },(ERROR: HttpErrorResponse) => {
      this.payBtnShow = true;
      this.PayBtn = true;
      this.PayStatus = false;
    }
  );

  }

  openFeeProcessPopUp(item) {
    // localStorage.clear();

    sessionStorage.setItem('TemplateCode', item.TemplateCode);
    let data = {};
    data['TclcId'] = this.Tclcdata[0]['TclcId']
    data['CertType'] = this.Tclcdata[0]['CertType']
    data['DestClg'] = this.Tclcdata[0]['DestClg']
    data['Reason'] = this.Tclcdata[0]['Reason']
    data['SnNo'] = this.Tclcdata[0]['SnNo']
    data['StuBranch'] = this.Tclcdata[0]['StuBranch']
    data['StuCollege'] = this.Tclcdata[0]['StuCollege']
    data['StuCourse'] = this.Tclcdata[0]['StuCourse']
    data['StuExam'] = this.Tclcdata[0]['StuExam']
    data['StuFaculty'] = this.Tclcdata[0]['StuFaculty']
    data['StuId'] = this.TclcSavedData[0]['StuId']
    const dialogRef4 = this.dialog.open(TclcFeesProcessComponent,
      {
        disableClose: true,
        width: "900px",
        height: "auto",
        data
      });
    dialogRef4.afterClosed().subscribe((result) => {
      this.ngOnInit();
    });
  }


  addnewrecord(item) {
    sessionStorage.setItem('TemplateCode', item.TemplateCode);
    let data = {};
    data['SnNo'] = this.sessionNo
    data['TemplateCode'] = item.TemplateCode
    data['StuName'] = this.TclcSavedData[0]['StuName']
    data['MotherName'] = this.TclcSavedData[0]['MotherName']
    data['FatherName'] = this.TclcSavedData[0]['FatherName']
    data['Mobile'] = this.TclcSavedData[0]['Mobile']
    data['StuPRN'] = this.TclcSavedData[0]['StuPRN']
    const dialogRef = this.dialog.open(PaymentReceiptComponent, {
      width: '140vh',
      // height: '80vh',
      data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  getRgId(TclcData) {
    const payload = {};
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId");
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        this.examform(res.data[0]['RgId'], TclcData)
        this.getFeeTempData(TclcData);
      }
      else {
        this.getFeeTempData(TclcData);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.getFeeTempData(TclcData);
    })
  }

  examform(RgId, TclcData) {
    const payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    this.umsService.fetchLatestEcid(payload)
      .subscribe((res) => {
        if (res.status) {
          this.getFeeTempData(TclcData);

        } else {
          this.getFeeTempData(TclcData);
        }

      }, (ERROR: HttpErrorResponse) => {
        this.getFeeTempData(TclcData);
      });

  }

  getTclc() {
    const payload = {};
    payload['CertType'] = this.TclcSavedData[0]['CertType'];
    payload['StuId'] = this.TclcSavedData[0]['StuId']
    this.umsService.GetTclc(payload).subscribe((res) => {
      if (res.status) {
        this.TclcId = res.data[0]['TclcId']
      }
    })
  }

}